import React from "react";
import { Link } from "react-router-dom";

const TotalMerchants = () => {
  const data = [
    {
      id: 1,
      bname: "Business Name",
      mname: "Merchant Name",
      email: "example@gmail.com",
      contact: "9898989898",
    },
    {
      id: 2,
      bname: "Business Name",
      mname: "Merchant Name",
      email: "example@gmail.com",
      contact: "9898989898",
    },
    {
      id: 3,
      bname: "Business Name",
      mname: "Merchant Name",
      email: "example@gmail.com",
      contact: "9898989898",
    },
    {
      id: 4,
      bname: "Business Name",
      mname: "Merchant Name",
      email: "example@gmail.com",
      contact: "9898989898",
    },
  ];
  return (
    <div>
      <div className="row min-vh-100">
        <div className="container justify-content-center">
          <div className="py-5 row d-flex justify-content-center align-items-center">
            <div className="d-flex mb-3 justify-content-around w-50">
              <h4 className=" text-center">Merchants</h4>
              <input
                className=" form-control"
                placeholder="Search Merchant By Name"
                type="search"
                name=""
                id=""
              />
            </div>

            <div className="row">
              {data.map((item) => {
                return (
                  <>
                    <div className="col-md-4 my-2">
                      <Link to="" className="text-decoration-none text-black">
                        <div className="card shadow p-3">
                          <div className="row">
                            <div className="col-md-5 align-self-center border-end">
                              <img
                                className="img-fluid"
                                src="https://images.unsplash.com/photo-1575936123452-b67c3203c357?auto=format&fit=crop&q=80&w=1000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1hZ2V8ZW58MHx8MHx8fDA%3D"
                                alt=""
                              />
                            </div>
                            <div className="col-md-7">
                              <h5>{item.bname}</h5>
                              <p className="mb-0">{item.mname}</p>
                              <p className="mb-0">{item.email}</p>
                              <p className="mb-0">{item.contact}</p>
                              <Link
                                className="btn banner text-white"
                                to={`/superadmin/totalmerchants/${item.id}`}
                              >
                                View
                              </Link>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalMerchants;
